export { DrawerTextClipboard } from './DrawerTextClipboard'
